import { render } from "./EditSession.vue?vue&type=template&id=2f168d47&scoped=true"
import script from "./EditSession.vue?vue&type=script&lang=js"
export * from "./EditSession.vue?vue&type=script&lang=js"

import "./EditSession.vue?vue&type=style&index=0&id=2f168d47&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f168d47"]])

export default __exports__